import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import FormLabel from '@material-ui/core/FormLabel';
import FormControl from '@material-ui/core/FormControl';

import { Field, reduxForm, SubmissionError } from 'redux-form';

import InputAdornment from '@material-ui/core/InputAdornment';
import TextField, { TextFieldAdornmentText } from 'components/fields/TextField';
import FormError from 'components/common/FormError';
import RadioButtonField from 'components/fields/RadioButtonField';
import RadioGroupField from 'components/fields/RadioGroupField';

import { accountSignUpCompany } from 'redux/modules/account';

import * as validate from 'utils/validate';
import * as normalize from 'utils/normalize';

import pxToRem from 'styles/pxToRem';

const styles = theme => ({
  grid: {
    marginTop: 15,
    '&:first-child': {
      marginTop: 0,
    },
  },
  error: {
    marginTop: 24,
  },
  typography: {
    textTransform: 'uppercase',
    textAlign: 'center',
    paddingBottom: 14,
    marginBottom: 24,
    marginTop: 24,
    borderBottom: `1px solid ${theme.palette.primary.A100}`,
  },
  trapField: {
    position: 'absolute',
    top: 0,
    left: 0,
    opacity: 0,
    zIndex: -1,
    width: 100,
    pointerEvents: 'none',
  },
  formLabel: {
    fontWeight: 400,
    marginBottom: 15,
    fontSize: pxToRem(14, 16),
  },
});

function onSubmit(values, dispatch) {
  if (values['Repeat Email']) {
    throw new SubmissionError({
      _error: 'Spam Rejected',
    });
  }
  return new Promise((resolve, reject) => {
    dispatch(accountSignUpCompany({
      values,
      resolve,
      reject,
    }));
  }).then(res => res,
    (err) => {
      throw new SubmissionError({
        _error: err.error,
      });
    });
}

const SignUpCompanyForm = ({ handleSubmit, error, className, classes }) => (
  <form
    className={className}
    noValidate
    autoComplete="off"
    onSubmit={handleSubmit}
  >
    {error &&
      <Grid
        container
        spacing={24}
      >
        <Grid
          item
          xs={12}
        >
          <FormError className={classes.error}>
            {error}
          </FormError>
        </Grid>
      </Grid>
    }
    <Field
      className={classes.trapField}
      id="Repeat Email"
      name="Repeat Email"
      placeholder="Repeat Email"
      component={TextField}
      size="lg"
      type="email"
      autocomplete="off"
      fullWidth
    />
    <Typography
      className={classes.typography}
      color="secondary"
    >
      Final Step and your Free account is set up
    </Typography>
    <Grid
      className={classes.grid}
      container
      spacing={24}
    >
      <Grid
        item
        xs={12}
      >
        <Field
          id="Company Name"
          name="Company Name"
          label="Company Name"
          placeholder="Enter Company Name"
          component={TextField}
          validate={[validate.required, validate.minLength4]}
          errorPlacement="bottom"
          size="lg"
          fullWidth
        />
      </Grid>
    </Grid>
    <Grid
      className={classes.grid}
      alignItems="flex-end"
      container
      spacing={24}
    >
      <Grid
        item
        xs={12}
        sm={6}
      >
        <Field
          id="Signer First Name"
          name="Signer First Name"
          label="Contact Person"
          placeholder="First Name"
          component={TextField}
          validate={[validate.required]}
          size="lg"
          fullWidth
        />
      </Grid>
      <Grid
        item
        xs={12}
        sm={6}
      >
        <Field
          id="Signer Last Name"
          name="Signer Last Name"
          placeholder="Last Name"
          component={TextField}
          validate={[validate.required]}
          size="lg"
          fullWidth
        />
      </Grid>
    </Grid>
    <Grid
      className={classes.grid}
      container
      spacing={24}
    >
      <Grid item>
        <FormControl role="group">
          <FormLabel className={classes.formLabel} component="legend">Gender</FormLabel>
          <Field
            name="Signer Gender"
            component={RadioGroupField}
          >
            <RadioButtonField value="Male" label="Male" size="xl" />
            <RadioButtonField value="Female" label="Female" size="xl" />
            <RadioButtonField value="Other" label="Other" size="xl" />
          </Field>
        </FormControl>
      </Grid>
    </Grid>
  </form>
);

SignUpCompanyForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  className: PropTypes.string,
  error: PropTypes.string,
  classes: PropTypes.shape({
    grid: PropTypes.string.isRequired,
    error: PropTypes.string.isRequired,
    trapField: PropTypes.string.isRequired,
  }).isRequired,
};

SignUpCompanyForm.defaultProps = {
  className: '',
  error: null,
  step: 1,
};

export default reduxForm({
  onSubmit,
})(withStyles(styles)(SignUpCompanyForm));



// WEBPACK FOOTER //
// ./src/components/account/SignUpCompany/SignUpCompanyForm.js